var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resizable-component",style:(_vm.style)},[_vm._t("default"),_vm._l((_vm.active),function(el){return [_c('div',{key:el,class:'resizable-' + el})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }